<template>
  <BbBtn size="x-small" color="#6222e3" :width="36" :height="36" class="insert_button" @click="$emit('click', $event)">
    <BbIcon size="small" name="plus-small" />
  </BbBtn>
</template>

<script>
export default {
  emits: ['click'],
};
</script>

<style lang="scss" scoped>
.insert_button {
  pointer-events: auto;
  border: 2px solid $bb-primary-3;
  background: $bb-neutral-0 !important;

  &:active {
    border: 2px solid rgb(221, 202, 236);
  }

  :deep(.v-btn__content) {
    color: $bb-primary-3;
  }

  &:hover {
    :deep(.v-btn__content) {
      color: $bb-neutral-0;
    }
  }
}

.button-as-icon {
  border: 2px solid rgb(221, 202, 236);
  cursor: default;

  :deep(.v-btn__content) {
    color: $bb-neutral-0;
  }
}
</style>
